module.exports = __webpack_public_path__ + "img/AIStudioFoundations.907c52c1.jpeg";